/**
* Sticky element
**/

;(function ($, window, _) { // eslint-disable-line no-extra-semi
    'use strict';

    /**
     * Focus component constructor
     * @param $element
     * @param target
     */
    var scrollButton = function ($element, options) {
        this._$el = $element;
        this._options = $.extend(false, scrollButton.config, options);

        this._init();
    };
    
    /*
     * Default settings
     */
    scrollButton.config = {
        classes: {
            start: 'set--start',
            end: 'set--end'
        }
    };

    scrollButton.prototype._init = function() {
        var self =this;

        var Timer = setTimeout(function(){
            this._update();
        }.bind(this), 1500)

        $(window).scroll(_.debounce(function(){
            this._update();
        }.bind(this), 1500));

        $(window).scroll(function(){
            clearTimeout(Timer);
            this._$el.removeClass(self._options.classes.start);
        }.bind(this));

        this._$el.bind('click', function(e){
            //console.log('click');
            e.preventDefault();
        });
    }

    scrollButton.prototype._update = function() {
        var self = this,
            windowTop = $(window).scrollTop(),
            documentHeight = $(document).height(),
            windowHeight = $(window).height();

            if(windowTop >= documentHeight - (2*windowHeight)) {
                self._$el.removeClass(self._options.classes.start);
				self._$el.addClass(self._options.classes.end);
			} else {
                self._$el.addClass(self._options.classes.start);
                self._$el.removeClass(self._options.classes.end);
			}
    }

     /**
     * Attach new focus
     * @private
     */
    scrollButton.prototype._attach = function () {
        var $el = $(this),
            options = $el.data('scroll-button') ? $el.data('scroll-button') : {};
    
        //console.log(options, $el);
        new scrollButton($el, options);
    };


    /**
     * Attach listeners to document
     */
    $(function () {
        /**
         * Travel through the DOM for data-focus attributes
         */
        //$('[data-scroll-button]').each(scrollButton.prototype._attach);

        $.fn.jqScrollButton = function () {
            $(this).each(scrollButton.prototype._attach);
        };
    });

})(jQuery, window, _);

